import { createFileRoute } from "@tanstack/react-router";

import { seo } from "@/lib/seo";
import { assertDraftRouteVisible } from "@/lib/draft-routes";
import { PagePlaceholder } from "@/components/site/PagePlaceholder";

export const Route = createFileRoute("/_lp/lp/sba-loans")({
  // Draft route: 404s on the live domain, renders normally elsewhere. See src/lib/draft-routes.ts.
  beforeLoad: assertDraftRouteVisible,
  head: () =>
    seo({
      title: "SBA Loan Package Preparation",
      description: "Lender-ready SBA loan packages prepared by Ivy League-trained consultants.",
      path: "/lp/sba-loans",
      noindex: true,
    }),
  component: Page,
});

function Page() {
  return <PagePlaceholder title={"SBA loan package preparation"} intro={"[SUPPLY: landing page copy]"} />;
}
